import { mdiCheckDecagramOutline, mdiCloseOctagonOutline } from "@mdi/js";
import Icon from "@mdi/react";
import clsx from "clsx";

import { DataCheckSVGIcon } from "components/SVGIcons";
import styles from "./style.module.scss";

interface IProps {
  credit?: string;
  credit_approved: string;
}

const getStatusClass = (credit_approved: string) => {
  switch (credit_approved) {
    case "approved":
      return "text-approvedBorder border border-approvedBorder";

    case "pending":
    case "needs_review":
      return "text-pendingBorder border border-pendingBorder";

    case "declined":
    case "declined_3_months":
    case "declined_6_months":
      return "text-declinedBorder border border-declinedBorder";

    case "do_not_contact":
      return "text-info border border-info";

    default:
      return "text-pendingBorder border border-pendingBorder";
  }
};

const getDisplayLabel = (credit_approved: string): string => {
  switch (credit_approved) {
    case "declined_3_months":
    case "declined_6_months":
      return "declined";
    case "do_not_contact":
      return "do not contact";
    default:
      return credit_approved;
  }
};

const isDeclinedStatus = (status: string): boolean => {
  return ["declined", "declined_3_months", "declined_6_months"].includes(status);
};

export default function CreditStatus({ credit = "", credit_approved }: Readonly<IProps>) {
  const displayLabel = credit || getDisplayLabel(credit_approved);

  return (
    <div className={clsx(styles.statusButton, getStatusClass(credit_approved))}>
      {isDeclinedStatus(credit_approved) || credit_approved === "do_not_contact" ? (
        <Icon path={mdiCloseOctagonOutline} className="flex-none size-5" />
      ) : (
        <>
          {credit_approved === "approved" ? (
            <Icon path={mdiCheckDecagramOutline} className="flex-none size-5" />
          ) : (
            <DataCheckSVGIcon className="flex-none size-5" />
          )}
        </>
      )}
      <span className="capitalize">{displayLabel}</span>
    </div>
  );
}
